import { Tag } from './Tag'
import styles from './EventRow.module.css'
import type { ApiEvent } from '../services/api'
import { formatEventDateParts } from '../utils/eventDate'

interface EventRowProps {
  event: ApiEvent
  onClick: () => void
}

export function EventRow({ event, onClick }: EventRowProps) {
  const { dayName, dayNum, time } = formatEventDateParts(event.event_date)

  return (
    <button className={styles.eventRow} onClick={onClick}>
      <div className={styles.dateCol}>
        <div className={styles.dayName}>{dayName}</div>
        <div className={styles.dayNum}>{dayNum}</div>
        <div className={styles.time}>{time}</div>
      </div>
      <div className={styles.content}>
        <div className={styles.title}>{event.title}</div>
        <div className={styles.location}>
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z" />
            <circle cx="12" cy="10" r="3" />
          </svg>
          {event.venue_name}
        </div>
        <div className={styles.tags}>
          <Tag variant="neutral">{event.kind}</Tag>
          {event.genre && <Tag variant="accent">{event.genre}</Tag>}
          <Tag variant="outline">{event.price}</Tag>
        </div>
      </div>
    </button>
  )
}
